import React from "react";

const LoadingScreen = ({ message, subtitle }) => (
  <div className="app-loading" role="status" aria-live="polite" aria-busy="true">
    <div className="app-loading-bg" aria-hidden="true">
      <span className="app-loading-orb app-loading-orb-1" />
      <span className="app-loading-orb app-loading-orb-2" />
    </div>
    <div className="app-loading-inner">
      <p className="app-loading-brand">
        <span className="app-loading-first">Mokhles</span>{" "}
        <span className="app-loading-last">Lajimi</span>
      </p>
      <p className="app-loading-role">{subtitle}</p>
      <div className="app-loading-track" aria-hidden="true">
        <span className="app-loading-fill" />
      </div>
      <p className="app-loading-message">{message}</p>
    </div>
  </div>
);

export default LoadingScreen;
